import React from "react";
import IntoleranceFilter from "~/assets/js/components/IntoleranceFilter";
import TagsFilter from "~/assets/js/components/TagFilters";
import { ACTIONS, useCategoryContext } from "../../CategoryProvider";

const Filters = () => {
    const { state, dispatch } = useCategoryContext();

    const handleFilterClick = (selectedTag) => {
        dispatch({ type: ACTIONS.TAG_FILTER, payload: { selectedTag } });
    };

    const handleIntolerancesFilter = (selectedIntolerances) => {
        dispatch({
            type: ACTIONS.INTOLERANCE_FILTER,
            payload: selectedIntolerances,
        });
    };

    // Do not show filters if we present coupons category
    if (state.isCoupon) {
        return null;
    }

    return (
        <div className="category-filters">
            <TagsFilter
                activeFilters={state.filterTags}
                tags={state.tags}
                handleClick={handleFilterClick}
                useUrls={state.isMainDish}
            />
            <IntoleranceFilter
                activeIntolerances={state.filterIntolerances}
                intolerances={state.intolerances}
                onFilter={handleIntolerancesFilter}
            />
        </div>
    );
};

export default Filters;
